/* ORDERS */
export const GET_USER = "GET_USERS"
export const ADD_USER = "ADD_USER"
export const ADD_USER_ERROR = "ADD_USER_ERROR"
export const UPDATE_USER = "UPDATE_USER"
export const GET_USER_SUCCESS = "GET_USERS_SUCCESS"
export const GET_USER_FAIL = "GET_USERS_FAIL"
export const GET_USERS_BY_ID = "GET_USERS_BY_ID"
export const GET_USERS_BY_ID_SUCCESS = "GET_USERS_BY_ID_SUCCESS"
export const START_FETCHING = "START_FETCHING"
export const GET_AUTHOR = "GET_AUTHOR"
export const GET_CRAFTSMAN = "GET_CRAFTSMAN"
export const GET_AUTHOR_SUCCESS = "GET_AUTHOR_SUCCESS"
export const GET_CRAFTSMAN_SUCCESS = "GET_CRAFTSMAN_SUCCESS"
export const SET_CRAFTSMAN = "SET_CRAFTSMAN"
export const ON_CHECKED_CRAFTSMAN = "ON_CHECKED_CRAFTSMAN"
export const ON_CHECKED_AUTHOR = "ON_CHECKED_AUTHOR"
